const WelcomeStep = (() => {

    let $welcomeStep;
    let pageData;

    return {
        openWelcomeStep: openWelcomeStep,
    }

    function openWelcomeStep(passJson) {
        $welcomeStep = $("#welcomeStep");

        Often.setCookie("FLOW_LANG", Often.null2Void(Often.getCookie("FLOW_LANG"), window._CF_LANG));

        const welcomeIcon = '<i class="welcome-hand"></i>';
        const title = i18next.t(login.welcomFlow, {userName: passJson.USER_NM}) + welcomeIcon;
        $welcomeStep.find(".js-welcome-title").html(title);
        $(document).scrollTop(0);
        $welcomeStep.fadeIn(0);
        $('footer').css("display", "none");
        $("#teamStep").fadeOut(0);
        addEvent(passJson);
        if(!Often.isGlobal()) {
            const isSns = passJson.isSns;
            GoogleTagManager.collect({event: isSns ? "new_signup5_b" : "new_signup6_a"});
        }
    }

    function addEvent(passJson) {
        const url = location.protocol + "//" + passJson.SUB_DOM_DATA.toLowerCase() + "." + location.hostname + "/corpsignup.act";

        $welcomeStep.find(".js-welcome-button").off("click").on("click", () => {
            if ($('.js-welcome-button').attr('start_yn') === 'Y') {
                exitWelcomePage(passJson);
                return;
            }

            if (Often.isMobile() || Often.isTablet()) {
                userTrack("invite-messenger");
                mobileShareLink(passJson, url);
            } else {
                userTrack("invite-kakaotalk");
                openKakaotalk(passJson, url);
            }
            updateWelcomeMsg();
        })
        $welcomeStep.find('.js-email-invite-btn').off('click').on('click', (e) => {
            userTrack("invite-email");
            $('.js-invite-layer.layer-email').css('display', '');
        })
        $welcomeStep.find(".js-copy-link").off("click").on("click", (e) => {
            userTrack("copy-invite-link");
            copyLink(passJson, url);
            updateWelcomeMsg(e);
            Often.toast("success", i18next.t('common:invitationLinkCopied'))
        });
        $welcomeStep.find('.js-textapp-invite-btn').off('click').on('click', (e) => {
            if (!(Often.isMobile() || Often.isTablet())) return;
            const {mobileOpenTextMessageApp = Mutil.noop} = passJson;
            userTrack("invite-text-app");
            mobileOpenTextMessageApp({ inviteMsg : getInviteText(passJson, url)});
            updateWelcomeMsg();
        })

        $welcomeStep.find('.js-invite-back').off('click').on('click', (e) => {
            $(e.target).closest('.js-invite-layer').css('display', 'none');
        })
        $welcomeStep.find(".js-invite-btn").off("click").on("click", () => {
            userTrack("invite-email-submit");
            clickInviteBtn(passJson);
        });
        $welcomeStep.find(".js-next-time-btn").off("click").on("click", () => {
            exitWelcomePage(passJson);
        });

        $welcomeStep.find(".js-email-input").off("blur").on("blur", (e) => {
            const $target = $(e.target);
            isUnValidEmailInput($target);

            const $inviteLayer = $target.closest('.js-invite-layer');
            const $filledInput = $inviteLayer.find('input').filter(function() { return $(this).val() !== '' });
            const validInputCnt = $filledInput.filter(function() { return !$(this).hasClass('input-error') }).length;
            const $inviteBtn = $inviteLayer.find('.js-invite-btn');
            if ($filledInput.length > 0 && validInputCnt > 0) {
                $inviteBtn.removeAttr('disabled');
            } else {
                $inviteBtn.attr('disabled', true);
            }
        });
        $welcomeStep.find(".js-join-input-wrap").off("keydown").on("keydown", keyDownEmailInput);

        $welcomeStep.find('.js-google-invite').off('click').on('click', () => {
            getUserList("Contact");
            updateApiSwitchBtn();
            $('.js-invite-layer.layer-google').css('display', '');
        })
        $welcomeStep.find('.js-google-api-switch').off('click').on('click', async (e) => {
            const $target = $(e.currentTarget);
            const apiKind = $target.attr('kind');
            updateApiSwitchBtn(apiKind);
            getUserList(apiKind);
        })
        $welcomeStep.find('.js-account-switch').off('click').on('click', () => {
            GoogleAccount.revokeToken();
            clearUserList(ListHelper.getNoDataHtml("SEARCH"));
            updateApiSwitchBtn();
            GoogleAccount.openGoogleAccount({_loadCallback: GoogleAccount.getContactUserList, _successCallback: drawUserList});
        })
        $welcomeStep.find('.js-google-invite-btn').off('click').on('click', () => {
            const $googleMemberUl = $('#GoogleMemberUl');
            let emailList = [];
            $googleMemberUl.find('.js-member-select:checked').each((i, user) => {
                emailList.push({EML: $(user).attr('email')});
            });
            userTrack("invite-google-submit");
            sendInviteMail(passJson, emailList);
        })
    }


    function moveMainPage(passJson = {}) {
        const {
            isSignUpBySnS = false,
            mobileSignInFunc = Mutil.noop ,
            WEBVIEW_YN = "N",
        } = passJson;
        const isWebView = "Y" === WEBVIEW_YN;
        if(isWebView) {
            mobileSignInFunc();
            return;
        }
        const firstLoginYn = "Y";
        const desktopGuideYn = "Y";
        const snsYn = passJson.isSns ? "Y" : "N";
        if (Often.isGlobal()) {
            GoogleTagManager.collect({event: `new_signup8${ !!isSignUpBySnS ? "_b" : "" }`});
        } else {
            GoogleTagManager.collect({event: passJson.isSns ? "conv_signup_gmail" : "conv_signup_email"});
        }
        CommonLogin.moveMainPage({firstLoginYn, desktopGuideYn, snsYn});
    }

    function exitWelcomePage(passJson) {
        const {
            mobileSignInFunc = Mutil.noop ,
            WEBVIEW_YN = "N",
        } = passJson;

        const isWebView = "Y" === WEBVIEW_YN;
        Mutil.mlog("웹뷰 여부 확인 : " + isWebView);
        if(isWebView) {
            mobileSignInFunc();
            return;
        }
        moveMainPage(passJson);
    }

    function mobileShareLink(passJson, url) {
        const {
            mobileOpenShareContents = Mutil.noop ,
            WEBVIEW_YN = "N",
        } = passJson;
        const shareData = {
            title: i18next.t(main.alert.joinTeam, {val: passJson.SUB_DOM_NM}),
            text: `${i18next.t(common.invitingYou, {val: passJson.USER_NM})}\n\n${i18next.t(common.invitingMsg, {val: passJson.SUB_DOM_NM})}\n\n${url}`
        };
        if (!!navigator.share) {
            navigator.share(shareData)
                .then(() => {})
                .catch(console.error);
            return;
        }

        const isWebView = "Y" === WEBVIEW_YN;
        if(isWebView) {
            mobileOpenShareContents(shareData);
            return;
        }
    }

    function copyLink(passJson, url) {
        const invitedText = getInviteText(passJson, url);
        if (Often.isMobile() || Often.isTablet()) {
            navigator.clipboard.writeText(invitedText);
            return;
        }

        Often.copyUrl(invitedText);
    }

    function getInviteText(passJson, url) {
        return `${url}?\n\n${i18next.t(common.invitingYou, {val: passJson.USER_NM})}\n\n${i18next.t(common.invitingMsg, {val: passJson.SUB_DOM_NM})}`
    }

    function clickInviteBtn(passJson) {
        const $emailInput = $welcomeStep.find(".js-email-input");
        const emailList = [];
        let isError = false;
        $.each($emailInput, (i, input) => {
            if ($(input).val() === "") return true;
            isError = isUnValidEmailInput($(input));
            if (!isError) emailList.push({EML: $(input).val()});
        });

        if (isError) return;
        sendInviteMail(passJson, emailList);
    }

    function sendInviteMail(passJson, emailList) {
        if (emailList.length === 0) {
            Often.toast("error", i18next.t(login.invalidInvitationEmail))
            return;
        }

        Ajax.executeApi(RestApi.POST.FLOW_TEAM_INVT_C001, {
            USER_ID: passJson.USER_ID,
            RGSN_DTTM: Time.localTime(),
            EML_REC: emailList,
            RENEWAL_YN: "Y",
            SIGNUP_YN:"Y"
        }, () => {
            Often.toast("success", i18next.t(main.alert.invitationEmailSent));
            if (Often.isGlobal()) {
                moveMainPage(passJson);
                return;
            }
            $welcomeStep.find('.js-welcome-main').css('display', '');
            $welcomeStep.find('.js-invite-layer').css('display', 'none');
            updateWelcomeMsg();
        });
    }

    function keyDownEmailInput(e) {
        if ($(e.target).closest(".js-email-input").length === 0) return;
        if (!KeyCheck.isKey(e, "ENTER")) return;
        const $joinInputHtml = $("#joinInputHtml").html();
        const $joinInputWrap = $welcomeStep.find(".js-join-input-wrap").visible();
        if ($joinInputWrap.find(".js-email-input").length > 4) {
            return Often.toast("error", i18next.t(main.alert.limitation, {val: $t(dictionary.email), count: 5}))
        }
        $joinInputWrap.find(".js-join-button-wrap").before($joinInputHtml);
        $joinInputWrap.find(".js-email-input:last").focus();
    }

    function isUnValidEmailInput($input) {
        const checkJson = Validation.checkInput($input);
        CommonJoin.changeInputErrorMsg($input, checkJson.errorMessage);
        return Object.keys(checkJson).length > 0;
    }

    function updateWelcomeMsg() {
        if (Often.isGlobal()) return;
        setTimeout(() => {
            const $welcomeBtn = $('.js-welcome-button');
            $('.js-join-text').text(i18next.t(common.beginEfficientCollab));
            $welcomeBtn.css('background', '#E134FF')
            $welcomeBtn.text(i18next.t(common.startFlow));
            $welcomeBtn.attr('start_yn', 'Y');
        }, 2000);
    }

    function openKakaotalk(passJson, url) {
        try {
            copyLink(passJson, url);
            location.href = 'kakaotalk://launch';
            $('.js-link-copy-desc').css('display', 'block');
        } catch (e) {
            console.error("kakaotalk open error");
        }
    }

    function getUserList(apiKind) {
        clearUserList();
        if (apiKind === "Contact") {
            userTrack("invite-google-contacts");
            GoogleAccount.openGoogleAccount({_loadCallback: GoogleAccount.getContactUserList, _successCallback: drawUserList});
        } else if (apiKind === "Workspace") {
            userTrack("invite-google-workspace");
            GoogleAccount.openGoogleAccount({_loadCallback: GoogleAccount.getWorkspaceUserList, _successCallback: drawUserList}); // admin#directory#users
        }
    }

    async function drawUserList(props) {
        if (typeof props === "undefined" || props === null) return;

        const { apiKind, users = [], otherContacts = [], nextPageToken } = props;
        const isContactApi = apiKind === "Contact";
        const isWorkspaceApi = apiKind === "Workspace";
        const records = isContactApi ? otherContacts : isWorkspaceApi ? users : [];
        const scrollFunc = () => {
            if (isContactApi) {
                GoogleAccount.getContactUserList();
            } else if (isWorkspaceApi) {
                GoogleAccount.getWorkspaceUserList();
            } else {
                Mutil.noop();
            }
        }

        if (!nextPageToken) pageData["NEXT_YN"] = "N";
        const $googleMemberUl = $('#GoogleMemberUl');
        await $googleMemberUl.drawListHelper({
            pageData: pageData,
            nextYn: pageData["NEXT_YN"],
            records: records,
            noDataHtml: ListHelper.getNoDataHtml("SEARCH"),
            targetObj: {
                scroll: $googleMemberUl.closest('.js-member-wrap'),
            },
            callback: {
                item: (records) => {
                    return Array.from(records).map(user => getUserListHtml(apiKind, user));
                },
                scroll: () => {
                    if (pageData["NEXT_YN"] === "N") return;
                    return scrollFunc();
                },
                click: (e) => {
                    const $target = $(e.target).closest('.js-member-info-list');
                    if ($target.length === 0) return;

                    const $targetCheckbox = $target.find('.js-member-select');
                    $targetCheckbox.prop('checked', !$targetCheckbox.is(':checked'));

                    const $googleInviteBtn = $('.js-google-invite-btn');
                    if ($googleMemberUl.find('.js-member-select:checked').length > 0) {
                        $googleInviteBtn.removeAttr('disabled');
                    } else {
                        $googleInviteBtn.attr('disabled', true);
                    }
                }
            }
        })
    }

    function getUserListHtml(dataType, user) {
        const isContactData = dataType === 'Contact';
        const isWorkspaceData = dataType === 'Workspace';
        if (!(isContactData || isWorkspaceData)) return;

        const defaultProfile = '/flow-renewal/assets/images/profile-default.svg';
        let profilePicture, name, email;
        try {
            if (isContactData) {
                profilePicture = user?.photos[0]?.url;
                name = user?.names[0]?.displayName;
                email = user?.emailAddresses[0]?.value;
            }
            else if (isWorkspaceData) {
                profilePicture = user?.thumbnailPhotoUrl;
                name = user?.name?.fullName;
                email = user?.primaryEmail;
            }
        } catch (e){
            // 구글에서 내려오는 데이터 중 이름, 메일 등이 누락된 경우 pass
            return;
        }

        return `<li class="member-info-list js-member-info-list">
                    <div class="member-details">
                        <img class="member-profile" src="${profilePicture ?? defaultProfile}" alt="">
                        <div class="member-info">
                            <p class="member-name">${name}</p>
                            <span class="member-mail">${email}</span>
                        </div>
                    </div>
                    <input id="check1" class="checkbox-item member-select js-member-select" type="checkbox" email="${email}">
                    <label for="check1" class="member-items"></label>
                </li>`;
    }

    function clearUserList(noDataHtml = '') {
        const $googleMemberUl = $('#GoogleMemberUl');
        $googleMemberUl.html(noDataHtml);
        pageData = {PG_NO: 1, NEXT_YN: 'Y'};
        GoogleAccount.setPageToken('');
    }

    function updateApiSwitchBtn(apiKind = 'Contact') {
        const $apiSwitchBtn = $('#googleApiSwitchBtn');
        if (apiKind === 'Contact') {
            $apiSwitchBtn.attr('kind', 'Workspace');
            $apiSwitchBtn.find('span').text('Google Workspace');
        } else if (apiKind === 'Workspace') {
            $apiSwitchBtn.attr('kind', 'Contact');
            $apiSwitchBtn.find('span').text('Google Contact');
        }
    }

    function userTrack(event) {
        if (!event) return;
        const UserTracker = UserTracker || requireModule('userTracker', {on: ['signup']})();
        UserTracker?.SignUpTracker()?.track(event);
    }
})();
